"use client";

import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import React from "react";
import useSmartPosition from "@/components/hooks/use-smart-position";
import { usePopoverPosition } from "@/components/providers/PopoverPositionProvider";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { NavigationMenuContentProps } from "../types";

function NavigationMenuContent({
  className,
  ...props
}: NavigationMenuContentProps) {
  const { triggerRef } = usePopoverPosition();
  const [setContentEl] = useSmartPosition<HTMLDivElement>(triggerRef);
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <NavigationMenuPrimitive.Content
      ref={setContentEl}
      data-slot="navigation-menu-content"
      className={cn(
        "rounded-sm data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 top-0 left-0 w-auto p-2 pr-2.5 absolute z-50",
        "group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-sm group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200 **:data-[slot=navigation-menu-link]:focus:ring-0 **:data-[slot=navigation-menu-link]:focus:outline-none",
        className,
        classes,
      )}
      {...native}
    />
  );
}

NavigationMenuContent.displayName = "NavigationMenu.Content";

export default NavigationMenuContent;
